<div>
  <div class="row">
    <div class="col px-md-3">
      <h2 class="font-title" [innerHTML]="title|translate"></h2>
      <h5 class="font-title" [innerHTML]="subtitle|translate" *ngIf="subtitle"></h5>
      <hr class="divider">
    </div>
  </div>
</div>
